export class NotificationManager {
  static show(message, type = 'success', options = {}) {
    const { isCartNotification = false } = options;

    const selector = isCartNotification ? '.cart-notification' : '.notification';
    const existingNotification = document.querySelector(selector);
    if (existingNotification) {
      existingNotification.remove();
    }

    const notification = document.createElement('div');
    notification.className = isCartNotification ?
      `cart-notification notification-${type}` :
      `notification notification-${type}`;

    if (isCartNotification) {
      notification.innerHTML = `
        <span class="cart-toast-text">Added</span>
        <button class="cart-toast-btn" id="view-order-btn">View Order</button>
      `;
    } else {
      notification.textContent = message;
    }

    if (isCartNotification) {
      const cartButton = document.querySelector('.cart-btn, #sidebar-cart-btn');
      let cartRect = { top: 20, right: 20 };

      if (cartButton) {
        cartRect = cartButton.getBoundingClientRect();
      }

      Object.assign(notification.style, {
        position: 'fixed',
        top: `${cartRect.top + cartRect.height + 10}px`,
        right: `${window.innerWidth - cartRect.right}px`,
        background: type === 'success' ? '#3E885B' : '#FF6B6B',
        backgroundColor: type === 'success' ? '#3E885B' : '#FF6B6B',
        color: 'white',
        padding: '8px 12px',
        borderRadius: '8px',
        boxShadow: '0 4px 12px rgba(0,0,0,0.2)',
        zIndex: '1001',
        fontWeight: '500',
        fontSize: '14px',
        transform: 'translateY(-10px) scale(0.9)',
        opacity: '0',
        transition: 'all 0.3s cubic-bezier(0.34, 1.56, 0.64, 1)',
        maxWidth: '200px',
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        pointerEvents: 'auto',
        backdropFilter: 'none',
        border: 'none'
      });
    } else {
      Object.assign(notification.style, {
        position: 'fixed',
        top: '20px',
        right: '20px',
        background: type === 'success' ? '#3E885B' :
                   (type === 'error' ? '#ef4444' :
                   (type === 'warning' ? '#f59e0b' : '#3b82f6')),
        color: 'white',
        padding: '12px 20px',
        borderRadius: '8px',
        boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
        zIndex: '1000',
        fontWeight: '500',
        transform: 'translateX(100%)',
        transition: 'transform 0.3s ease',
        maxWidth: '300px',
        wordWrap: 'break-word'
      });
    }

    document.body.appendChild(notification);

    if (isCartNotification) {
      const cartToastText = notification.querySelector('.cart-toast-text');
      const cartToastBtn = notification.querySelector('.cart-toast-btn');

      if (cartToastText) {
        Object.assign(cartToastText.style, {
          fontSize: '14px',
          fontWeight: '500',
          color: 'white'
        });
      }

      if (cartToastBtn) {
        Object.assign(cartToastBtn.style, {
          background: 'rgba(255, 255, 255, 0.2)',
          border: '1px solid rgba(255, 255, 255, 0.3)',
          borderRadius: '6px',
          color: 'white',
          fontSize: '12px',
          fontWeight: '600',
          padding: '4px 8px',
          cursor: 'pointer',
          transition: 'all 0.2s ease',
          whiteSpace: 'nowrap'
        });

        cartToastBtn.addEventListener('mouseenter', () => {
          cartToastBtn.style.background = 'rgba(255, 255, 255, 0.3)';
        });

        cartToastBtn.addEventListener('mouseleave', () => {
          cartToastBtn.style.background = 'rgba(255, 255, 255, 0.2)';
        });

        cartToastBtn.addEventListener('click', () => {
          const event = new CustomEvent('showOrderConfirmation');
          document.dispatchEvent(event);
          if (notification.parentNode) {
            notification.remove();
          }
        });
      }
    }

    requestAnimationFrame(() => {
      if (isCartNotification) {
        notification.style.transform = 'translateY(0) scale(1)';
        notification.style.opacity = '1';
      } else {
        notification.style.transform = 'translateX(0)';
      }
    });

    const duration = isCartNotification ? 2000 : 3000;
    setTimeout(() => {
      if (isCartNotification) {
        notification.style.transform = 'translateY(-10px) scale(0.9)';
        notification.style.opacity = '0';
      } else {
        notification.style.transform = 'translateX(100%)';
      }

      setTimeout(() => {
        if (notification.parentNode) {
          notification.remove();
        }
      }, 300);
    }, duration);

    return notification;
  }

  static success(message) {
    return this.show(message, 'success');
  }

  static error(message) {
    return this.show(message, 'error');
  }

  static info(message) {
    return this.show(message, 'info');
  }

  static warning(message) {
    return this.show(message, 'warning');
  }

  static cartSuccess(message) {
    return this.show(message, 'success', { isCartNotification: true });
  }

  /**
   * Show cart notepad with current items (replaces old product toast)
   * @param {Array} cartItems - All current cart items
   * @param {Object} newItem - The newly added item
   */
  static showCartNotepad(cartItems, newItem) {
    import('../components/cart/CartNotepad.js').then(module => {
      const { CartNotepad } = module;
      const notepad = new CartNotepad();
      notepad.show(cartItems, newItem);
    });
  }

  /**
   * Show product-specific toast next to the product that was added to cart
   * @deprecated Use showCartNotepad instead
   * @param {HTMLElement} productElement - The product card element
   * @param {Object} item - The item that was added to cart
   */
  static showProductToast(productElement, item) {
    const existingToasts = document.querySelectorAll('.product-toast');
    existingToasts.forEach(toast => toast.remove());

    const toast = document.createElement('div');
    toast.className = 'product-toast';
    toast.innerHTML = `
      <div class="product-toast-content">
        <i class="fas fa-check-circle product-toast-icon"></i>
        <span class="product-toast-text">Added to cart!</span>
        <button class="product-toast-button" data-action="view-order">
          <span>View Order</span>
          <i class="fas fa-shopping-cart"></i>
        </button>
      </div>
    `;

    const productRect = productElement.getBoundingClientRect();
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;

    const toastWidth = 240;
    const toastHeight = 50;
    const margin = 8;

    let left = productRect.right + scrollLeft + margin;
    let top = productRect.top + scrollTop + margin;

    if (left + toastWidth > window.innerWidth) {
      left = productRect.left + scrollLeft - toastWidth - margin;
    }

    if (top < scrollTop + margin) {
      top = scrollTop + margin;
    }

    if (top + toastHeight > scrollTop + window.innerHeight - margin) {
      top = scrollTop + window.innerHeight - toastHeight - margin;
    }

    Object.assign(toast.style, {
      position: 'absolute',
      left: `${left}px`,
      top: `${top}px`,
      background: 'var(--color-success, #3E885B)',
      color: 'white',
      borderRadius: '12px',
      padding: '12px 16px',
      boxShadow: '0 8px 24px rgba(62, 136, 91, 0.3), 0 4px 8px rgba(0, 0, 0, 0.1)',
      zIndex: '1002',
      fontSize: '14px',
      fontWeight: '500',
      maxWidth: '240px',
      minWidth: '200px',
      transform: 'translateY(10px) scale(0.9)',
      opacity: '0',
      transition: 'all 0.3s cubic-bezier(0.34, 1.56, 0.64, 1)',
      pointerEvents: 'auto'
    });

    const content = toast.querySelector('.product-toast-content');
    Object.assign(content.style, {
      display: 'flex',
      alignItems: 'center',
      gap: '8px'
    });

    const icon = toast.querySelector('.product-toast-icon');
    Object.assign(icon.style, {
      fontSize: '16px',
      color: 'white',
      flexShrink: '0'
    });

    const text = toast.querySelector('.product-toast-text');
    Object.assign(text.style, {
      flex: '1',
      fontSize: '14px',
      fontWeight: '500'
    });

    const button = toast.querySelector('.product-toast-button');
    Object.assign(button.style, {
      background: 'rgba(255, 255, 255, 0.15)',
      border: '1px solid rgba(255, 255, 255, 0.2)',
      borderRadius: '6px',
      color: 'white',
      fontSize: '12px',
      fontWeight: '600',
      padding: '6px 10px',
      cursor: 'pointer',
      transition: 'all 0.2s ease',
      display: 'flex',
      alignItems: 'center',
      gap: '4px',
      flexShrink: '0'
    });

    button.addEventListener('mouseenter', () => {
      button.style.background = 'rgba(255, 255, 255, 0.25)';
      button.style.transform = 'translateY(-1px)';
    });

    button.addEventListener('mouseleave', () => {
      button.style.background = 'rgba(255, 255, 255, 0.15)';
      button.style.transform = 'translateY(0)';
    });

    button.addEventListener('click', (e) => {
      e.stopPropagation();
      const event = new CustomEvent('showOrderConfirmation');
      document.dispatchEvent(event);

      toast.remove();
    });

    document.body.appendChild(toast);

    requestAnimationFrame(() => {
      toast.style.transform = 'translateY(0) scale(1)';
      toast.style.opacity = '1';
    });

    setTimeout(() => {
      if (toast.parentNode) {
        toast.style.transform = 'translateY(-10px) scale(0.95)';
        toast.style.opacity = '0';

        setTimeout(() => {
          if (toast.parentNode) {
            toast.remove();
          }
        }, 300);
      }
    }, 4000);

    return toast;
  }
}